import { createContext } from 'react';

const FormErrorsContext = createContext(null);

export default FormErrorsContext;
